import React from "react";

const rotations = {
	up: "180deg",
	down: "0deg",
	left: "90deg",
	right: "-90deg"
}

export default function Chevron({ size = 50, color = "#ffffff", style = {}, direction = "up", className = "" }) {

	return <svg
		className={["imgIcon", "chevron", className].join(" ")}
		style={{
			height: size,
			width: size,
			transform: `rotate(${rotations[direction]})`,
			fill: color,
			...style
		}}
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 28 28"
	>
		<path d="M14,18.7c-0.3,0-0.6-0.1-0.8-0.3l-7-7c-0.5-0.5-0.5-1.2,0-1.7c0.5-0.5,1.2-0.5,1.7,0l6.2,6.2l6.2-6.2
		c0.5-0.5,1.2-0.5,1.7,0c0.5,0.5,0.5,1.2,0,1.7l-7,7C14.6,18.6,14.3,18.7,14,18.7z"/>
	</svg>
}